module.exports = __webpack_public_path__ + "img/Delivered.611b51a1.svg";